
  import { defineComponent } from "vue"
  import { useStore } from "vuex"

  export default defineComponent({
    name: "ThemeSwitcher",
    setup() {
      const store = useStore()

      const setMode = (event: any) => {
        if (event.target.checked) store.dispatch("setTheme", "dark")
        else store.dispatch("setTheme", "light")
      }

      let theme: any = window.localStorage.getItem("theme")
      if (theme == "dark") theme = true
      else theme = false

      return { setMode, theme }
    },
  })
